import { useState } from "react";
import { Theme } from "@mui/material/styles";
import { useMediaQuery } from "@mui/material";
import Search from "./Search";
// import Message from "./Message";
import Profile from "./Profile";
import Notification from "./Notification";
import MobileSection from "./MobileSection";
import IconButton from "components/@extended/IconButton";
import useConfig from "hooks/useConfig";
import DrawerHeader from "layout/MainLayout/Drawer/DrawerHeader";
import { MenuOrientation, ThemeMode } from "types/config";
import { useServerHealthContext } from "contexts/ServerHealthContext";
import { Chip } from "@mui/material";
import { Refresh, Send, ShieldTick } from "iconsax-react";
import ConnectKiteDialog from "modal/ConnectKiteDialog";
import { dispatch } from "store";
import { openSnackbar } from "store/reducers/snackbar";
import serverCall from "api/serverCall";
import api from "api/api";
import { useTheme } from "@mui/material";

// ==============================|| HEADER - CONTENT ||============================== //

const HeaderContent = () => {
  const [openKiteConnectModal, setOpenKiteConnectModal] =
    useState<boolean>(false);
  const { menuOrientation } = useConfig();
  const { kiteStatus, setKiteStatus } = useServerHealthContext();
  const theme = useTheme();

  const downLG = useMediaQuery((theme: Theme) => theme.breakpoints.down("lg"));

  const handleConnect = () => {
    setOpenKiteConnectModal(true);
  };

  const handleCheckStatus = async () => {
    try {
      const response = await serverCall.get<any>(api.getLiveTickStatus());
      if (response?.loggedIn) {
        dispatch(
          openSnackbar({
            open: true,
            close: true,
            message: `Kite status: Connected`,
            variant: "alert",
            alert: {
              color: "success",
            },
            anchorOrigin: {
              vertical: "top",
              horizontal: "center",
            },
          })
        );
      } else {
        dispatch(
          openSnackbar({
            open: true,
            close: true,
            message: `Kite status: Not Connected`,
            variant: "alert",
            alert: {
              color: "error",
            },
            anchorOrigin: {
              vertical: "top",
              horizontal: "center",
            },
          })
        );
      }
      setKiteStatus(response?.loggedIn);
    } catch (error) {
      dispatch(
        openSnackbar({
          open: true,
          close: true,
          message: `Failed to check status`,
          variant: "alert",
          alert: {
            color: "error",
          },
          anchorOrigin: {
            vertical: "top",
            horizontal: "center",
          },
        })
      );
    }
  };

  const iconBackColor =
    theme.palette.mode === ThemeMode.DARK
      ? "background.default"
      : "secondary.100";

  return (
    <>
      {menuOrientation === MenuOrientation.HORIZONTAL && !downLG && (
        <DrawerHeader open={true} />
      )}
      {!downLG && <Search />}
      {kiteStatus ? (
        <Chip
          icon={<ShieldTick />}
          color={"success"}
          label="Market Live"
          size="small"
        />
      ) : (
        <Chip
          label="Connect"
          icon={<Send />}
          clickable
          color="primary"
          size="small"
          onClick={handleConnect}
          sx={{ borderRadius: "20px" }}
        />
      )}
      <IconButton
        color="secondary"
        variant="light"
        aria-label="open profile"
        aria-haspopup="true"
        onClick={handleCheckStatus}
        size="large"
        sx={{ color: "secondary.main", bgcolor: iconBackColor, p: 1, ml: 2 }}
      >
        <Refresh variant="Bold" />
      </IconButton>
      <Notification />
      {/* <Message /> */}
      {!downLG && <Profile />}
      {downLG && <MobileSection />}
      {openKiteConnectModal && (
        <ConnectKiteDialog
          open={openKiteConnectModal}
          handleClose={setOpenKiteConnectModal}
        />
      )}
    </>
  );
};

export default HeaderContent;
